
import axios from 'axios'

import { Message, Loading } from 'element-ui'
import config from '../config'
import router from '../router'

const instance = axios.create({
  baseURL: config.apiHost,
  withCredentials: true
})

// http response 拦截器
instance.interceptors.response.use(
  (response) => {
    const code = response.data.code

    if (code === 401) {
      Message({
        showClose: true,
        message: '登录信息已失效，请重新登录',
        type: 'error',
        duration: 2000
      })
      sessionStorage.removeItem('user-nickName')
      sessionStorage.removeItem('all-zMenu')
      router.push('/')
    }
    if (code === 403) {
      window.location.hash = '#/403'
    }
    if (code === 20000) {
      Message({
        showClose: true,
        message: JSON.stringify(response.data),
        type: 'error',
        duration: 2000
      })
    }
    return response
  }, (error) => {
    const code = error.response.status
    const loadingInstance = Loading.service()
    loadingInstance.close()
    Message({
      showClose: true,
      message: error.response.data.error.message + error.response.data.error.details,
      type: 'error',
      duration: 2000
    })
    if (code === 401) {
      Message.warning('登录信息已失效，请重新登录！')
      sessionStorage.removeItem('user-nickName')
      sessionStorage.removeItem('all-zMenu')
      router.push('/')
    }
    if (code === 405) {
      Message.warning('您暂无此权限，请联系管理员！')
    }

    return Promise.reject(error)
  }
)

// http request 拦截器
instance.interceptors.request.use((config) => {
  // 获取token
  const token = localStorage.getItem('accessToken')

  // 设置参数格式
  if (!config.headers['Content-Type']) {
    config.headers = {
      'Content-Type': 'application/json'
    }
  }
  // 添加token到headers
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }

  return config
}, (error) => {
  return Promise.reject(error)
}
)

export default instance
